import {
    PremiumPreviewStatus,
    PremiumPreviewData,
    PremiumPreviewSource,
} from '../../store/schema/PremiumPreviewData';
import { logUsage } from 'owa-analytics';
import { assertNever } from 'owa-assert';

// data point when upsell (go premium) clicked
const UPSELL_CLICKED = 'EditorProofing_UpsellClicked';

//  Location as Misc data within basic Skittle
const UPSELL_CLICKED_LOCATION_BASIC_SKITTLE = 'ContextualUpsell_SkittleOpenUpsellCallout';

//Location as Misc data within UPSELL_CLICKED Premium Preview , source: Skittle
const UPSELL_CLICKED_LOCATION_PP_SOURCE_SKITTLE_ACTIVATED =
    'PremiumPreview_SkittleOpenOpt-inDialog';

// Location as Misc data within UPSELL_CLICKED Premium Preview , source: CC_card
const UPSELL_CLICKED_LOCATION_PP_SOURCE_CONTEXTUAL_CARD_ACTIVATED =
    'PremiumPreview_CCardOpenOpt-inDialog';

// Location as Misc data within UPSELL_CLICKED Premium Preview, source: Settings
const UPSELL_CLICKED_LOCATION_PP_SOURCE_SETTINGS_ACTIVATED = 'PremiumPreview_SettingsOpenOpt-in';

// Location as Misc data within UPSELL_CLICKED during premium preview, within Skittle
const UPSELL_CLICKED_LOCATION_SKITTLE_ACTIVATED = 'PremiumPreview_SkittleCountdownCallout';

// Location as Misc data within UPSELL_CLICKED -Expired skittle
const UPSELL_CLICKED_LOCATION_SKITTLE_EXPIRED = 'PremiumPreview_SkittlePreviewEndCallout';

// Location as Misc data within UPSELL_CLICKED during premium preview, within Settings
const UPSELL_CLICKED_LOCATION_SETTINGS_ACTIVATED = 'PremiumPreview_SettingsCountdown';

// Location as Misc data within UPSELL_CLICKED -Expired settings
const UPSELL_CLICKED_LOCATION_SETTINGS_EXPIRED = 'PremiumPreview_SettingsDialogAfter';

// Location as Misc data within UPSELL_CLICKED contexual card when status is activaed
const UPSELL_CLICKED_LOCATION_CC_ACTIVATED = 'PremiumPreview_CCardCountdown';

// Location as Misc data within UPSELL_CLICKED contexual card -Expired conte
const UPSELL_CLICKED_LOCATION_CC_EXPIRED = 'PremiumPreview_CCAfterPreviewEnd';

// Regular Settings Dialog (without Enhanced Upsell)
const Regular_SettingsDialog = 'Regular_SettingsDialog';

// Contextual Card with Contextual Upsell (Premium count)
const ContextualUpsell_CCard = 'ContextualUpsell_CCard';

// Regular Contextual Card (without Enhanced Upsell)
const Regular_CCard = 'Regular_CCard';

type UpsellClickedUI = 'Skittle' | 'PremiumPreview' | 'ContexualCard' | 'SettingsCompose';

export function logOnUpsellClicked(
    upsellClickedUI: UpsellClickedUI,
    premiumPreviewData: PremiumPreviewData,
    type: string
) {
    const miscData_location = getMiscDataLocation(
        upsellClickedUI,
        premiumPreviewData.premiumPreviewSource,
        premiumPreviewData.premiumPreviewStatus
    );
    logUsage(
        UPSELL_CLICKED,
        {
            type: type,
            location: miscData_location,
        },
        { isCore: true }
    );
}

function getMiscDataLocation(
    upsellClickedUI: UpsellClickedUI,
    premiumPreviewSource: PremiumPreviewSource,
    premiumPreviewStatus: PremiumPreviewStatus
): string {
    let miscData_location: string = '';
    switch (upsellClickedUI) {
        case 'PremiumPreview':
            switch (premiumPreviewSource) {
                case 'settings':
                    miscData_location = UPSELL_CLICKED_LOCATION_PP_SOURCE_SETTINGS_ACTIVATED;
                    break;
                case 'skittle':
                    miscData_location = UPSELL_CLICKED_LOCATION_PP_SOURCE_SKITTLE_ACTIVATED;
                    break;
                case 'contextualCard':
                    miscData_location = UPSELL_CLICKED_LOCATION_PP_SOURCE_CONTEXTUAL_CARD_ACTIVATED;
                    break;
                case 'none':
                    break;
                default:
                    assertNever(premiumPreviewSource);
            }
            break;

        case 'Skittle':
            switch (premiumPreviewStatus) {
                case PremiumPreviewStatus.Activated:
                    miscData_location = UPSELL_CLICKED_LOCATION_SKITTLE_ACTIVATED;
                    break;
                case PremiumPreviewStatus.Expired:
                    miscData_location = UPSELL_CLICKED_LOCATION_SKITTLE_EXPIRED;
                    break;
                case PremiumPreviewStatus.New:
                    break;
                case PremiumPreviewStatus.Unknown:
                    miscData_location = UPSELL_CLICKED_LOCATION_BASIC_SKITTLE;
                    break;
                default:
                    assertNever(premiumPreviewStatus);
            }
            break;

        case 'ContexualCard':
            switch (premiumPreviewStatus) {
                case PremiumPreviewStatus.Activated:
                    miscData_location = UPSELL_CLICKED_LOCATION_CC_ACTIVATED;
                    break;
                case PremiumPreviewStatus.Expired:
                    miscData_location = UPSELL_CLICKED_LOCATION_CC_EXPIRED;
                    break;
                case PremiumPreviewStatus.New:
                    miscData_location = ContextualUpsell_CCard;
                    break;
                case PremiumPreviewStatus.Unknown:
                    miscData_location = Regular_CCard;
                    break;
                default:
                    assertNever(premiumPreviewStatus);
            }
            break;

        case 'SettingsCompose':
            switch (premiumPreviewStatus) {
                case PremiumPreviewStatus.Activated:
                    miscData_location = UPSELL_CLICKED_LOCATION_SETTINGS_ACTIVATED;
                    break;
                case PremiumPreviewStatus.Expired:
                    miscData_location = UPSELL_CLICKED_LOCATION_SETTINGS_EXPIRED;
                    break;
                case PremiumPreviewStatus.New:
                    break;
                case PremiumPreviewStatus.Unknown:
                    miscData_location = Regular_SettingsDialog;
                    break;
                default:
                    assertNever(premiumPreviewStatus);
            }
            break;

        default:
            assertNever(upsellClickedUI);
    }
    return miscData_location;
}
